<template>
  <div class="relative flex-container d-flex flex-column ai-center">
    <template v-if="!onlyContent">
      <div v-if="isMobile" class="mobile-top-nav header-2">Insights</div>
      <div v-if="!isMobile" class="mg-150" />
    </template>
    <div
      class="section-wrapper d-flex flex-column"
      v-bind:class="{ 'mg-150': !isMobile, 'mg-100': isMobile }"
    >
      <template v-if="!onlyContent">
        <div v-if="!isMobile" class="header-2">Insights</div>
        <div v-if="!isMobile" class="text-1 mg-50 opaque">
          데이터몬스터즈는 차별화된 시각으로 해결책을 제시합니다.
          <br />현상 뒤의 본질을 꿰뚫어 보는 눈, <br />데이터몬스터즈의 솔루션이
          특별한 이유입니다.
        </div>
        <div v-if="!isMobile" class="mg-150" />
      </template>
      <div class="flex-container d-flex flex-column">
        <div v-if="!insights" class="flex-container center">
          <v-progress-circular color="#1c1c1c" indeterminate />
        </div>
        <template v-else>
          <div class="flex-container d-flex flex-column">
            <div
              class="flex-container relative d-flex flex-column"
              @mouseleave="hoverCategory = null"
            >
              <div class="flex-container">
                <template v-for="divisionMap in insights.entries()">
                  <div
                    v-if="divisionMap[0] === 'All'"
                    class="insight-nav-cell text-2"
                    :key="divisionMap[0]"
                    v-bind:class="{
                      active: category === divisionMap[0],
                      'text-3': isMobile,
                    }"
                    @click="onClickNavCell(divisionMap[0])"
                    @mouseover="hoverCategory = divisionMap[0]"
                  >
                    <div>{{ divisionMap[0] }}</div>
                    <div v-if="!isMobile">{{ divisionMap[1].length }}</div>
                  </div>

                  <div
                    v-else
                    class="insight-nav-cell text-2"
                    v-bind:class="{
                      active: category === divisionMap[0],
                      'text-3': isMobile,
                    }"
                    :key="divisionMap[0]"
                    @click="onClickNavCell(divisionMap[0])"
                    @mouseover="hoverCategory = divisionMap[0]"
                  >
                    <div>{{ divisionMap[0] }}</div>
                    <div v-if="!isMobile">
                      {{ getTotalLength(divisionMap[1]) }}
                    </div>
                  </div>
                </template>
              </div>
              <v-expand-transition>
                <div
                  v-if="hoverCategory && !isMobile"
                  class="division-list-wrapper"
                  @mouseleave="hoverCategory = null"
                >
                  <div
                    class="division-list"
                    v-for="divisionMap in insights.entries()"
                    :key="`divison-list-${divisionMap[0]}`"
                    v-bind:class="{
                      invisible:
                        hoverCategory === 'All' ||
                        hoverCategory !== divisionMap[0],
                    }"
                  >
                    <div
                      v-for="divisionItem in divisionMap[1].entries()"
                      class="insight-division text-2"
                      :key="divisionItem[0]"
                      v-bind:class="{
                        'division-active': division === divisionItem[0],
                      }"
                      @click="onClickDivision(divisionItem[0])"
                    >
                      <div>{{ divisionItem[0] }}</div>
                      <div>{{ divisionItem[1].length }}</div>
                    </div>
                  </div>
                </div>
              </v-expand-transition>
            </div>

            <div class="space-15" />

            <div v-if="isMobile" class="flex-container ai-center">
              <div class="header-4 color-blue">
                {{ `${getCategoryNumber()} Insights` }}
              </div>
              <v-spacer />

              <v-select
                v-if="category !== 'All'"
                class="mobile-divison-select text-3"
                dense
                hide-details
                :items="getMapEntry(insights.get(category))"
                outlined
                placeholder="소분류"
                color="#1c1c1c"
                @change="(item) => onClickDivision(item[0])"
              >
                <template v-slot:item="{ item }">
                  {{ item[1][0].division.name }}
                </template>
              </v-select>
            </div>
            <div class="space-15" />

            <div
              class="flex-container wrap behind"
              v-bind:class="{ 'd-flex flex-column': isMobile }"
            >
              <div
                class="insight-wrapper"
                v-for="insight in getCurrentPage()"
                :key="insight.id"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    class="insight-card relative d-flex flex-column"
                    outlined
                    :elevation="hover ? 5 : 0"
                    @click="onClickInsight(insight.id)"
                  >
                    <div class="insight-image">
                      <v-img
                        :height="isMobile ? '230px' : '450px'"
                        :src="insight.thumbnail.url"
                      >
                        <v-fade-transition>
                          <v-img
                            v-if="hover"
                            :height="isMobile ? '230px' : '450px'"
                            :src="insight.cover.url"
                          />
                        </v-fade-transition>
                      </v-img>
                    </div>
                    <div
                      class="flex-container flex-1 d-flex flex-column"
                      v-bind:class="{ 'pa-6': !isMobile, 'pa-3': isMobile }"
                    >
                      <div class="flex-container flex-3">
                        <div class="insight-header">
                          <div
                            class="text-3 color-grey thin flex-1 flex-container ai-center"
                          >
                            {{
                              `${insight.category.name} > ${insight.division.name}`
                            }}
                          </div>
                          <div
                            class="text-1 insight-title bold color-black flex-1"
                          >
                            {{ parseTitle(insight.title) }}
                          </div>
                        </div>
                        <div class="insight-logo">
                          <img
                            v-if="insight.authorIcon && insight.authorIcon.url"
                            class="insight-author-icon"
                            :src="insight.authorIcon.url"
                          />
                          <div
                            v-else
                            class="text-2 insight-author-text color-grey"
                          ></div>
                        </div>
                      </div>
                      <div
                        class="text-2 flex-2 thin color-black flex-container ai-center"
                      >
                        {{ parseSummary(insight.summary) }}
                      </div>
                    </div>
                  </v-card>
                </v-hover>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="mg-50" />
      <div v-if="page" class="flex-container center">
        <div
          class="btn-prev ma-2"
          v-bind:class="{ disabled: page === 1 }"
          @click="prevPage"
        />
        <div v-for="index in pageLimit" :key="`pagination-${index}`">
          <div v-if="page === index" class="page-index text-1 bold ma-2">
            {{ index }}
          </div>
          <div
            v-else
            class="page-index text-1 color-grey bold ma-2"
            @click="setPage(index)"
          >
            {{ index }}
          </div>
        </div>
        <div
          class="btn-next ma-2"
          v-bind:class="{ disabled: page === pageLimit }"
          @click="nextPage"
        />
      </div>
      <div class="mg-50" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["onlyContent"],
  data: () => ({
    insights: null,
    category: "All",
    hoverCategory: null,
    division: null,
    page: null,
    pageLimit: null,
  }),
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
    numberPerPage() {
      return this.isMobile ? 3 : 6;
    },
  },
  methods: {
    async parseData() {
      const response = await this.$apollo.query({
        query: require("../graphql/GetPublishedInsights.gql"),
      });

      const ok = response.data.GetPublishedInsights.ok;
      if (!ok) {
        alert("서버 에러");
        return [];
      }
      const rawInsights = response.data.GetPublishedInsights.insights;

      const map = new Map();

      map.set("All", rawInsights);

      for (const insight of rawInsights) {
        const key = insight.category.name;
        const subKey = insight.division.name;
        const collection = map.get(key);
        if (collection) {
          const subCollection = collection.get(subKey);
          if (subCollection) {
            subCollection.push(insight);
          } else {
            collection.set(subKey, [insight]);
          }
        } else {
          const divisionMap = new Map();
          divisionMap.set(subKey, [insight]);
          map.set(key, divisionMap);
        }
      }

      this.page = 1;
      this.pageLimit = Math.ceil(rawInsights.length / this.numberPerPage);
      this.insights = map;
    },
    getTotalLength(map) {
      let length = 0;
      for (const entry of map.entries()) {
        length += entry[1].length;
      }
      return length;
    },

    parseTitle(title) {
      if (title.length < 25) {
        return title;
      }
      return title.substring(0, 22) + "...";
    },

    parseSummary(summary) {
      if (summary.length < 50) {
        return summary;
      }
      return summary.substring(0, 47) + "...";
    },
    getMapEntry(map) {
      return [...map.entries()];
    },
    getCurrentPage() {
      let start = (this.page - 1) * this.numberPerPage;
      let end = this.page * this.numberPerPage;
      const limit = this.insights.get("All").length;
      if (end > limit) end = limit;

      if (this.division) {
        return this.insights
          .get(this.category)
          .get(this.division)
          .slice(start, end);
      } else {
        if (this.category === "All") {
          return this.insights.get(this.category).slice(start, end);
        } else {
          let collection = [];
          const map = this.insights.get(this.category);
          for (const entry of map.entries()) {
            collection = collection.concat(...entry[1]);
          }
          return collection.slice(start, end);
        }
      }
    },
    getCategoryNumber() {
      if (this.division) {
        return this.insights.get(this.category).get(this.division).length;
      } else {
        if (this.category === "All") {
          return this.insights.get(this.category).length;
        } else {
          let collection = [];
          const map = this.insights.get(this.category);
          for (const entry of map.entries()) {
            collection = collection.concat(...entry[1]);
          }
          return collection.length;
        }
      }
    },

    nextPage() {
      if (this.page === this.pageLimit) return;
      this.page++;
    },
    prevPage() {
      if (this.page === 1) return;
      this.page--;
    },
    setPage(page) {
      this.page = page;
    },
    onClickNavCell(category) {
      this.category = category;
      this.division = null;
      this.page = 1;
    },
    onClickDivision(division) {
      if (!this.isMobile) {
        this.category = this.hoverCategory;
      }
      this.division = division;
      this.page = 1;
    },
    onClickInsight(id) {
      this.$router.push(`/insight/${id}`);
    },
  },
  mounted() {
    this.parseData();
  },
};
</script>

<style scoped>
.insight-nav-cell {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-width: 300px;
  height: 40px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  border-top: 2px solid #bbb;
  color: #bbb;
  justify-content: space-between;
  align-items: center;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  padding: 10px 20px;
}

.insight-nav-cell:hover {
  font-weight: bold;
  border-top: 2px solid black;
  color: black;
  transition: 0.3s ease-in-out;
}

.active {
  font-weight: bold;
  border-top: 2px solid black;
  color: black;
  transition: 0.3s ease-in-out;
  cursor: default;
}

.division-list-wrapper {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  z-index: 2;
}

.division-list {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-width: 300px;
  max-height: 160px;
  overflow: auto;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.insight-division {
  width: 100%;
  height: 40px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  border-top: 1px solid #bbb;
  color: #bbb;
  background: white;
  justify-content: space-between;
  align-items: center;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  padding: 10px 20px;
}

.insight-division:first-child {
  border-top: none;
}

.insight-division:hover {
  font-weight: bold;
  color: black;
  transition: 0.3s ease-in-out;
}

.division-active {
  font-weight: bold;
  color: black;
  cursor: default;
}

.invisible {
  opacity: 0;
}

.insight-wrapper {
  width: 33.3%;
  height: 700px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding: 10px;
  position: relative;
}

.insight-wrapper:nth-child(3n + 1) {
  padding-left: 0;
  padding-right: 20px;
}

.insight-wrapper:nth-child(3n) {
  padding-left: 20px;
  padding-right: 0;
}

.insight-card {
  width: 100%;
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.behind {
  z-index: -1;
}

.insight-header {
  height: 100%;
  -ms-flex: 2;
  -webkit-flex: 2;
  flex: 2;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.insight-image {
  width: 100%;
  height: 450px;
}

.insight-logo {
  height: 100%;
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
}

.insight-author-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.insight-author-text {
  width: fit-content;
  word-break: keep-all;
}

.insight-title {
  width: 100%;
  word-break: keep-all;
  font-size: 20px;
}

@media only screen and (max-width: 880px) {
  .insight-nav-cell {
    padding: 0;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
  }

  .insight-wrapper {
    width: 100%;
    height: 400px;
    padding: 10px 0;
  }

  .insight-image {
    height: 220px;
  }

  .insight-title {
    font-size: 15px;
  }

  .insight-summary {
    margin-top: 15px;
  }

  .insight-wrapper:nth-child(3n + 1) {
    padding-left: 0;
    padding-right: 0;
  }

  .insight-wrapper:nth-child(3n) {
    padding-left: 0;
    padding-right: 0;
  }

  .mobile-divison-select {
    max-width: 120px;
  }
}
</style>
